// @noflow
import Icon from '../';
import PropTypes from 'prop-types';
import { QUESTION } from '~/core/constants/icons/general';
import * as React from 'react';

const propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string
};

const DeviceIcon = ({ active, className, icon, model, type, ...props }) => (
    <Icon className={className} icon={icon ? icon : QUESTION} {...props} set={icon ? 'device' : 'general'} />
);

DeviceIcon.propTypes = propTypes;

export default DeviceIcon;



// WEBPACK FOOTER //
// ./src/core/icons/device-icon/component.js